
<template>
  <div>
      <div style="width: 99%;  margin-top: 12px;margin-left: 10px; margin-bottom: 10px;">
          <el-input  placeholder="搜索文件名" v-model="departmentInput" @input="handleInput" clearable> <i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
      </div>
      <div style="display: flex; ">
        <div style="width: 25%; height: 80vh;">
          <treeCompoents :expandedKeysList="expandedKeysList" :dataTree="dataTree" @handleEventGetFileFolder="handleEventGetFileFolder" @handleEventKeys="handleEventKeys"  @handleEventGetListFile="handleEventGetListFile"></treeCompoents>
        </div>
        <div style="width: 75%; height: 80vh; padding-top: 7px;padding-left: 4px;">
          <searchTable :dataFile="dataFile" :fromData="fromData" :fileDataList="dataTree"  @handleEventGetListFile="handleEventGetListFile"  ></searchTable>
        </div>
      </div>
  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import loadingUtils from "../utils/loading";
import { getSubject,} from "@/api/firstClassApi";

import treeCompoents from "./treeCompoents";
import searchTable from "./searchTable";

import{getFileFolderAPI , listFileAPI, selectFileAPI} from "@/api/fileSpace.js"

export default {
  components: { treeCompoents, searchTable },
  name: "FileSpace",
  props: {  },
  data(){
    return{

      expandedKeysList:[1],

      departmentInput:'',
      dataTree:[],
      dataFile:{},
      fromData:{
        pageNo:1,
        pageSize:10,
        total:0
      }
    }
  },
  mounted(){
    this.getFileFolder()
    setTimeout(()=>{
    this.getListFile(this.dataTree[0].folderId)

    },500)





  },
  methods:{

    handleFoeach(itme){
      if(itme){
        itme.isPopover = true
        if(itme.children && itme.children.length > 0){
          itme.children.forEach((e)=>{
            this.handleFoeach(e)
          })
        }
      }
      return itme
    },

    handleEventKeys(event){
      this.expandedKeysList = event
    },

    getFileFolder(folderId = ''){
        getFileFolderAPI(1).then(res=>{
            if(res.code === 200){
                if(res.data && res.data.length > 0){
                    res.data.forEach((itme)=>{
                      itme = this.handleFoeach(itme)
                    })
                }else{
                    res.data = []
                }
                this.dataTree = res.data

            }else{
                this.$message({ type: 'error', message: res.message })
            }
        })
    },

    getListFile( id = '',tepy,pageNo,pageSize){
        let data={
            pageNo:pageNo || 1,
            folderId:id,
            pageSize:pageSize || 10,
            isSort:tepy || 0,
        }
        listFileAPI(data).then(res=>{
            if(res.code === 200){
                this.dataFile = res.data
                this.fromData.total  = res.data.allTotal
            }else{
                this.$message({ type: 'error', message: res.message })
            }
        })
    },

    handleEventGetFileFolder(id){
        this.getFileFolder(id)
    },

    handleEventGetListFile(id,tepy,pageNo,pageSize){
        // 
        this.getListFile(id,tepy,pageNo,pageSize)

    },


    handleInput(e){

      let data = {
          fileName:this.departmentInput,
          suffix:this.departmentInput,
          startTime:'',
          endTime:'',
          callerType:1,
      }

      if(this.departmentInput){
        setTimeout(()=>{
          selectFileAPI(data).then(res=>{
              if(res.code === 200){
                  this.dataFile.list = res.data
              }else{
                  this.$message({ type: 'error', message: res.message })
              }
          })
        },1000)

      }else{
        this.getListFile()
      }
    },
  }
}

</script>


<style lang="less" scoped>

    .btn{
        background-color: #1890ff;
        border-color: #1890ff;
    }

    /deep/ .el-card__body{
          padding: 0px;
    }

    /deep/ .el-input__inner{
        height: 30px;
    }

    /deep/ .el-input__prefix{
        margin-top: -5px;
    }


    /deep/ .el-tree-node.is-current > .el-tree-node__content{
        color: #1890ff;
        background: #e8f4ff;
    }

    .add:hover{
        padding: 10px 10px;
        background: #4992df;
        color: #fff;
        border-radius: 5px;
    }

    /deep/ .el-drawer__header{
        font-weight: 900;
        font-size: 18px;
        background: #f5f7fa;
        padding: 15px 20px;
    }

    /deep/.el-divider--horizontal{
        margin-top: -26px;
    }

    /deep/ .el-dialog__header{
        text-align: start;
    }

    /deep/ .el-drawer__header{
        text-align: start;
    }

    /deep/ .el-input__suffix-inner{
        display: flex;
        margin-top: -3px;
    }

    /deep/ .el-range__close-icon{
        position: absolute;
        right: 0px;
    }
    /deep/ .el-range-separator{
        margin-top: -10px;
    }

    /deep/ .el-icon-date{
        display: none;
    }
    .no_click {
        pointer-events: none;
    }



</style>
























// WEBPACK FOOTER //
// src/FileSpace/FileSpace.vue